export enum ProviderRegistrationStatus {
    ValidationError,
    MissingUserName,
    Available,
    Unavailable,
    AlreadyRegistered,
    EulaAccepted
}
